import * as angular from 'angular';
import { first } from 'rxjs/operators';
import { FeatureFlag, FeatureFlagsFacade } from '@mode/shared/contract-common';

export const SignInToggleOptionsComponent: angular.IComponentOptions = {
  controller: class {
    static $inject = ['$location', 'FeatureFlagsFacade'];
    private optionsEnabled: boolean;
    private aadScimEnabled: boolean;
    private autoRedirectToSso: boolean;

    constructor(
      private $location,
      private featureFlagsFacade: FeatureFlagsFacade
    ) {
      this.featureFlagsFacade
        .asObservable(FeatureFlag.AzureActiveDirectoryScim)
        .pipe(first())
        .subscribe((enabled) => {
          this.aadScimEnabled = enabled;
        });
      this.featureFlagsFacade
        .asObservable(FeatureFlag.AutoRedirectToProvidedSSO)
        .pipe(first())
        .subscribe((enabled) => {
          this.autoRedirectToSso = enabled;
        });
    }

    $onInit() {
      const params = this.$location.search();
      if (this.autoRedirectToSso && params.redirect_to_sso) {
        this.showOptions();
      }
    }

    showOptions() {
      this.optionsEnabled = true;
    }

    toggleOptions() {
      this.optionsEnabled = !this.optionsEnabled;
    }
  },
  controllerAs: 'ctrl',
  bindings: {
    optionsEnabled: '<',
  },
  transclude: true,
  template: `
  <div class="sign-in-toggle-options-container" ng-class="{ 'aad-scim-enabled': ctrl.aadScimEnabled }">
    <div class="view-more-toggler" ng-click="ctrl.showOptions()" ng-if="!ctrl.optionsEnabled && !ctrl.aadScimEnabled">View more sign-in options</div>
    <div class="view-more-toggler" ng-click="ctrl.toggleOptions()" ng-if="ctrl.aadScimEnabled">
      <span ng-if="!ctrl.optionsEnabled">View more sign-in options</span>
      <span ng-if="ctrl.optionsEnabled">Hide sign-in options</span>
    </div>

    <hr ng-if="ctrl.optionsEnabled && !ctrl.aadScimEnabled"/>
    <div ng-if="ctrl.optionsEnabled" class="options-animated">
      <ng-transclude></ng-transclude>
    </div>
  </div>
  `,
};
